import { render, staticRenderFns } from "./ApplicationWrapWithHeader.vue?vue&type=template&id=ef61abde"
import script from "./ApplicationWrapWithHeader.vue?vue&type=script&lang=js"
export * from "./ApplicationWrapWithHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports